import Glide from '@glidejs/glide';
//import useMarquee from './useMarquee.js';

const activeBullet = "glide__bullet--active";

if (document.querySelector('#QuotesGlide')) {
    const el = document.querySelector('#QuotesGlide');
    const quoteSlider = new Glide(el, {
        type: 'carousel',
        perView: 2,
        gap: 0,
        breakpoints: {
            /* 992: {
                perView: 2
            }, */
            768: {
                perView: 1
            },
        }
    });
    quoteSlider.mount();
}

if (document.querySelector('#NewsGlide')) {
    const changeActiveBullet = (newIndex, containerElement) => {
        const glideDir = containerElement.querySelector(
            `[data-glide-dir="=${newIndex}"]`
        );

        const currentActive = containerElement.querySelector(`.${activeBullet}`);
        if (currentActive) {
            currentActive.classList.remove(activeBullet);
        }

        if (glideDir) glideDir.classList.add(activeBullet);
    };
    const el = document.querySelector('#NewsGlide');
    const newsBulletsContainer = el.querySelector('.glide__bullets');
    const newsSlider = new Glide(el, {
        type: 'carousel',
        perView: 3,
        breakpoints: {
            992: {
                perView: 2
            },
            576: {
                perView: 1
            },
        }
    });
    newsSlider.mount();
    newsSlider.on("run", () => {
        requestAnimationFrame(() => {
          changeActiveBullet(newsSlider.index, newsBulletsContainer);
        });
    });
}